import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { searchTakeovers, setSearchParameters } from 'actions/admin/takeovers';
import { performSearch, mergeSearchParameters } from 'components/adminTable/AdminTableHelper';
import routes from 'routes';

import { Link } from 'react-router-dom';
import AdminPage from '../../presentational/AdminPage';
import AdminContentWrapper from '../../presentational/AdminContentWrapper';
import SearchTakeoversForm from './SearchTakeoversForm';
import AdminTable from 'components/adminTable/AdminTable';
import Loader from 'common/Loader';

const columns = [
    {
        title: 'ID',
        id: 'id',
        align: 'right',
        render: takeover => <Link to={routes.admin.takeover.replace(':takeoverId', takeover.id)}>{takeover.id}</Link>
    },
    {
        title: 'Storage site title',
        id: 'storageSiteTitle',
        render: takeover => takeover.storageSite.title
    },
    {
        title: 'Number of tenants',
        id: 'tenantCount',
    },
    {
        title: 'Status',
        id: 'status',
    },
];

const Takeovers = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const searchResult = useSelector(state => state.admin.takeovers.searchResult);
    const searchParametersFromState = useSelector(state => state.admin.takeovers.searchParameters);

    const defaultParameters = {
        query: undefined,
        page: 0,
        pageSize: 20,
        sortByColumn: 'name',
        sortDirection: 'asc'
    };

    const search = (parameters) => {
        const searchParameters = mergeSearchParameters(parameters, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    };

    const performSearchObject = {
        searchParametersFromState,
        setSearchParametersToState: parameters => dispatch(setSearchParameters(parameters)),
        searchResult,
        search,
        apiCall: parameters => {
            dispatch(searchTakeovers(parameters));
        },
        location,
        history,
        isInitializedRef: useRef()
    };

    useEffect(() => {
        const searchParameters = mergeSearchParameters({}, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    }, []);

    const handleSearchFormSubmit = formValues => {
        search({ ...defaultParameters, ...formValues, page: 0 });
    };

    const handleSort = sortingParameters => {
        search(sortingParameters);
    };

    const handlePageChange = newPage => {
        search({ page: newPage });
    };

    const handlePageChangeSize = newPageSize => {
        search({ page: 0, pageSize: newPageSize });
    };

    return (
        <AdminPage title="Takeovers">
            <AdminContentWrapper type="listing">

                <SearchTakeoversForm
                    searchParameters={searchParametersFromState}
                    onSubmit={handleSearchFormSubmit}
                />

                <div>
                    {
                        searchResult.isLoading && <Loader />
                    }
                    {
                        searchResult.items && (
                            <AdminTable
                                isPaged
                                items={searchResult.items}
                                count={searchResult.count}
                                page={searchResult.page}
                                pageSize={searchResult.pageSize}
                                columns={columns}
                                sortByColumn={columns.find(c => c.id === searchParametersFromState.sortByColumn)}
                                sortDirection={searchParametersFromState.sortDirection}
                                onSort={handleSort}
                                onPageChange={handlePageChange}
                                onPageChangeSize={handlePageChangeSize}
                            />
                        )
                    }
                </div>
            </AdminContentWrapper>
        </AdminPage>
    );
};

export default Takeovers;
